var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgNewArrivals = function SvgNewArrivals(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.145 1.368a1.256 1.256 0 1 0-1.777 1.777L6.71 8.487H3.802c-.65 0-1.178.563-1.178 1.257S3.152 11 3.802 11H9.822c.32 0 .61-.136.822-.356.22-.212.356-.502.356-.822V3.803c0-.651-.563-1.179-1.256-1.179-.694 0-1.257.528-1.257 1.179V6.71L3.145 1.368Z",
    fill: "#096222"
  })));
};
export default SvgNewArrivals;